import * as i0 from '@angular/core';
import { inject, input, Component, computed, signal, output, ApplicationRef, createComponent, Injectable } from '@angular/core';
import { Location, NgClass } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgxButtonComponent } from '@digipay/ngx-button';
function SnackBarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "ngx-icon", 7);
    i0.ɵɵlistener("click", function SnackBarComponent_Conditional_1_Template_ngx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.goBack());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "arrow-right")("type", "Linear");
  }
}
function SnackBarComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 9);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "Check-Circle")("type", "Bold");
  }
}
function SnackBarComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 10);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "info-circle")("type", "Bold");
  }
}
function SnackBarComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "info-circle")("type", "Bold");
  }
}
function SnackBarComponent_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 12);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "Error-circle")("type", "Bold");
  }
}
function SnackBarComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.config().description);
  }
}
function SnackBarComponent_Conditional_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 15);
    i0.ɵɵlistener("clickHandler", function SnackBarComponent_Conditional_11_Conditional_1_Template_ngx_button_clickHandler_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.actionClicked());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap("link");
    i0.ɵɵproperty("size", "tiny");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config().leftAction.buttonText, " ");
  }
}
function SnackBarComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, SnackBarComponent_Conditional_11_Conditional_1_Template, 2, 4, "ngx-button", 13);
    i0.ɵɵelement(2, "div", 14);
    i0.ɵɵelementStart(3, "ngx-icon", 7);
    i0.ɵɵlistener("click", function SnackBarComponent_Conditional_11_Template_ngx_icon_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.config().leftAction.showButton ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "close")("type", "linear");
  }
}
const SNACKBAR_DEFAULT_STATE = {
  message: 'با موفقیت ثبت شد!',
  duration: 3000,
  description: '',
  status: 'success',
  backButton: false,
  leftAction: undefined
};
let SnackBarComponent = /*#__PURE__*/(() => {
  class SnackBarComponent {
    constructor() {
      this.snackBarService = inject(SnackbarService);
      this.config = input.required();
      this.location = inject(Location);
    }
    goBack() {
      this.location.back();
    }
    close() {
      this.snackBarService.closeSnackBar();
    }
    actionClicked() {
      this.snackBarService.clickOnAction();
    }
    static {
      this.ɵfac = function SnackBarComponent_Factory(t) {
        return new (t || SnackBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SnackBarComponent,
        selectors: [["lib-snack-bar"]],
        inputs: {
          config: [i0.ɵɵInputFlags.SignalBased, "config"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 12,
        vars: 5,
        consts: [[1, "radius-giant", "py-small", "px-minus", "d-flex", "justify-content-center", "align-items-center", "surface-high-contrast"], [1, "d-flex", "gap-small", "align-items-center"], [1, "mr-small"], [1, "d-flex", "flex-column", "pr-minus"], [1, "b-2", "text-onback-high"], [1, "text-onback-low", "c-3"], [1, "d-flex", "align-items-center"], ["classes", "text-onback-high fs-24 cursor-pointer", 3, "click", "name", "type"], [1, "horizontal-divider"], ["classes", "text-onback-success fs-24", 3, "name", "type"], ["classes", "text-onback-warning fs-24", 3, "name", "type"], ["classes", "text-onback-brand fs-24", 3, "name", "type"], ["classes", "text-onback-error fs-24", 3, "name", "type"], [3, "size", "style"], [1, "horizontal-divider", "ml-medium"], [3, "clickHandler", "size"]],
        template: function SnackBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, SnackBarComponent_Conditional_1_Template, 3, 2, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, SnackBarComponent_Case_3_Template, 1, 2)(4, SnackBarComponent_Case_4_Template, 1, 2)(5, SnackBarComponent_Case_5_Template, 1, 2)(6, SnackBarComponent_Case_6_Template, 1, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 3)(8, "span", 4);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, SnackBarComponent_Conditional_10_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, SnackBarComponent_Conditional_11_Template, 4, 3, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.config().backButton ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(3, (tmp_1_0 = ctx.config().status) === "success" ? 3 : tmp_1_0 === "warning" ? 4 : tmp_1_0 === "info" ? 5 : tmp_1_0 === "error" ? 6 : -1);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(ctx.config().message);
            i0.ɵɵadvance();
            i0.ɵɵconditional(10, ctx.config().description ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(11, ctx.config().leftAction ? 11 : -1);
          }
        },
        dependencies: [NgxIcon, NgxButtonComponent],
        styles: [".horizontal-divider[_ngcontent-%COMP%]{width:1px;height:28px;background-color:var(--border-tint)}.cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}"]
      });
    }
  }
  return SnackBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SnackContainerComponent = /*#__PURE__*/(() => {
  class SnackContainerComponent {
    constructor() {
      this.snackbarService = inject(SnackbarService);
      this.config = computed(() => this.snackbarService.globalConfig());
      this.isOpen = computed(() => this.snackbarService.isOpen());
    }
    static {
      this.ɵfac = function SnackContainerComponent_Factory(t) {
        return new (t || SnackContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SnackContainerComponent,
        selectors: [["lib-snack-container"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 3,
        consts: [["snackBackground", ""], [1, "snack-background", "inverted", 3, "ngClass"], [1, "snack-container", "inverted", 3, "ngClass"], [3, "config"]],
        template: function SnackContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "lib-snack-bar", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.isOpen() ? "open" : "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.isOpen() ? "open" : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("config", ctx.config());
          }
        },
        dependencies: [SnackBarComponent, NgClass],
        styles: [".host-snackbar{position:absolute;z-index:1000;direction:rtl;top:0;width:100%;display:flex;justify-content:center;align-items:center;transform:translateY(-40px);height:272px}.snack-background[_ngcontent-%COMP%]{height:100%;transition:opacity .4s linear;background:linear-gradient(180deg,#b3b3b3 50%,#b3b3b3e6 70%,#fff0);display:flex;justify-content:center;align-items:center;z-index:1001;opacity:0;position:absolute;width:100%}.snack-background.open[_ngcontent-%COMP%]{opacity:1}.snack-container[_ngcontent-%COMP%]{position:absolute;opacity:0;top:0;transition:all .6s cubic-bezier(.47,.33,0,1.13);max-width:360px}.snack-container.open[_ngcontent-%COMP%]{top:100px;z-index:1002;opacity:1}"]
      });
    }
  }
  return SnackContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SnackbarService = /*#__PURE__*/(() => {
  class SnackbarService {
    constructor() {
      this.isOpen = signal(false);
      this.globalConfig = signal(SNACKBAR_DEFAULT_STATE);
      this.onAction = output();
      this.onClose = output();
      this.appRef = inject(ApplicationRef);
    }
    openSnackBar(config = null) {
      this.resetSnackBar();
      const tempConfig = {
        ...this.globalConfig()
      };
      if (config) {
        for (const key in config) {
          tempConfig[key] = config[key];
        }
        this.globalConfig.set(tempConfig);
      }
      const hostElement = document.body;
      this.snackbarContainer = document.createElement('div');
      this.snackbarContainer.classList.add('host-snackbar');
      hostElement.appendChild(this.snackbarContainer);
      this.snackbarComponentRef = createComponent(SnackContainerComponent, {
        hostElement: this.snackbarContainer,
        environmentInjector: this.appRef.injector
      });
      this.appRef.attachView(this.snackbarComponentRef.hostView);
      this.snackbarComponentRef.changeDetectorRef.detectChanges();
      setTimeout(() => {
        this.isOpen.set(true);
      }, 0);
      this.timeoutSubscription = setTimeout(() => {
        this.closeSnackBar();
      }, this.globalConfig().duration);
      return this;
    }
    closeSnackBar(output = undefined) {
      if (this.timeoutSubscription) {
        clearTimeout(this.timeoutSubscription);
      }
      this.isOpen.set(false);
      this.onClose.emit(output);
      setTimeout(() => {
        this.snackbarComponentRef.destroy();
        this.globalConfig.set(SNACKBAR_DEFAULT_STATE);
      }, 500);
    }
    clickOnAction() {
      this.onAction.emit();
    }
    resetSnackBar() {
      if (this.timeoutSubscription) {
        clearTimeout(this.timeoutSubscription);
      }
      this.isOpen.set(false);
      this.snackbarComponentRef?.destroy();
      this.globalConfig.set(SNACKBAR_DEFAULT_STATE);
    }
    static {
      this.ɵfac = function SnackbarService_Factory(t) {
        return new (t || SnackbarService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SnackbarService,
        factory: SnackbarService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SnackbarService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SnackContainerComponent, SnackbarService };
